import React from "react";
import RateCardConfigForm from "./RateCardConfigForm";

function RateCardNew({companyContractId, isConfigureMode}) {
  return (
    <div>
      <RateCardConfigForm companyContractId={companyContractId} isConfigureMode={isConfigureMode}/>
    </div>
  );
}

export default RateCardNew;